import { combineReducers } from 'redux';
import modalReducer from './Modal/Modal.reducer';
import toastReducer from './Toast/Toast.reducer';
import authReducer from './Auth/Auth.reducer';
import userCreateReducer from './UserCreate/UserCreate.reducer';
import userUpdateReducer from './UserUpdate/UserUpdate.reducer';
import adminUserListReducer from './Admin/UsersList/UsersList.reducer';
import adminDashboardReducer from './Admin/Dashboard/Dashboard.reducer';
import sensorDetailsReducer from './SensorDetails/SensorDetails.reducer';

export type IRootStore = ReturnType<typeof rootReducer>;
export const rootReducer = combineReducers({
  modal: modalReducer,
  toast: toastReducer,
  auth: authReducer,
  userCreate: userCreateReducer,
  userUpdate: userUpdateReducer,
  sensorDetail: sensorDetailsReducer,

  admin: combineReducers({
    usersList: adminUserListReducer,
    dashboard: adminDashboardReducer,
  }),
});
